import { render, staticRenderFns } from "./ModalDesempenho.vue?vue&type=template&id=3677dd6c&scoped=true"
import script from "./ModalDesempenho.vue?vue&type=script&lang=js"
export * from "./ModalDesempenho.vue?vue&type=script&lang=js"
import style0 from "./ModalDesempenho.vue?vue&type=style&index=0&id=3677dd6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677dd6c",
  null
  
)

export default component.exports